export const students_empty = [
  {
    id: "",
    student_id: "",
    admission_id: "",
    pen: "",
    apaar: "",
    adhaar: "",
    admission_date: "",
    admission_catagory: "general",
    admission_scheme: "",
    discount: "0",
    cast: "",
    is_active: "ACTIVE",
    class_id: "",
    class_name: "",
    section_id: "",
    section_name: "",
    roll_number: 0,
    girl_single_child: "NO",
    physically_disabled: "NO",
    is_ews: "NO",
    admission_class: "",
    tc_number: "",
    tc_issue_date: "",
    totalWorkingDays: "",
    totalPresentDays: "",
    board_reg_no: "",
    board_roll_no: "",
    transport_details: {
      mode: "",
      stop_name: "",
      vehicle_no: "",
    },
    personal_details: {
      name: "",
      height: "",
      blood_group: "",
      correspondence_address: {
        addressline1: "",
        addressline2: "",
        city: "",
        state: "",
        pincode: "",
      },
      permanent_address: {
        addressline1: "",
        addressline2: "",
        city: "",
        state: "",
        pincode: "",
      },
      dob: "",
      gender: "",
    },
    guardian_details: {
      name: "",
      relation: "",
      occupation: "",
      contact: "",
      email: "",
    },
    father_details: {
      name: "",
      occupation: "",
      contact: "",
      email: "",
      education: "",
    },
    mother_details: {
      name: "",
      occupation: "",
      contact: "",
      email: "",
      education: "",
    },
    previous_school: {
      name: "",
      marks: {
        maths: "",
        hindi: "",
        english: "",
        science: "",
        computer: "",
      },
    },
  },
];

export const new_admission_template = [
  {
    id: "",
    student_id: "",
    admission_id: "",
    pen: "",
    apaar: "",
    adhaar: "",
    admission_date: "",
    admission_catagory: "new",
    admission_scheme: "Non RTE",
    discount: "0",
    cast: "GEN",
    is_active: "ACTIVE",
    class_id: "",
    class_name: "",
    section_id: "",
    section_name: "",
    roll_number: 0,
    girl_single_child: "NO",
    physically_disabled: "NO",
    is_ews: "NO",
    admission_class: "",
    tc_number: "",
    tc_issue_date: "",
    totalWorkingDays: "",
    totalPresentDays: "",
    board_reg_no: "",
    board_roll_no: "",
    transport_details: {
      mode: "",
      stop_name: "",
      vehicle_no: "",
    },
    personal_details: {
      name: "",
      height: "",
      blood_group: "",
      correspondence_address: {
        addressline1: "",
        addressline2: "",
        city: "",
        state: "",
        pincode: "",
      },
      permanent_address: {
        addressline1: "",
        addressline2: "",
        city: "",
        state: "",
        pincode: "",
      },
      dob: "",
      gender: "",
    },
    guardian_details: {
      name: "",
      relation: "",
      occupation: "",
      contact: "",
      email: "",
      adhaar: "",
      annual_income: "",
    },
    father_details: {
      name: "",
      occupation: "",
      contact: "",
      email: "",
      education: "",
      adhaar: "",
      annual_income: "",
    },
    mother_details: {
      name: "",
      occupation: "",
      contact: "",
      email: "",
      education: "",
      adhaar: "",
      annual_income: "",
    },
    previous_school: {
      name: "",
      last_class_attended: "",
      marks: {
        maths: "",
        hindi: "",
        english: "",
        science: "",
        computer: "",
      },
    },
  },
];
